module.exports = {
  friends: {
    oneActorHasMultipleNewFriends: '%(username1)s has %(nbOfFriends)d new friends',
    twoSingles: '%(username1)s and %(username2)s are now friends',
  },
  loadMore: 'Load more catches',
  endOfFeed: "All this contest's catches are displayed !",
  joinTeam: {
    joinButton: 'Join your team',
    teamNotFound:
      'We could not find a team for this code. Please double check your code, or contact us if you need further support.',
    getTeamError: 'An error has occured. Please try again or contact us if you need further support.',
    alreadyJoined: 'You are already registered !',
    pleaseLogin: 'Please login to your FishFriender account to join a team.',
    joinedAlert: 'Team joined, congrats !',
    team: {
      teamName: 'Team name: ',
      joinCode: 'Code for your teammates to join: ',
    },
    teamFullAlert: 'The team you want to join is full, sorry about that !',
  },
  joinWithPassword: {
    joinButton: 'Join the event',
    joinText: 'Please fill in the password given by the organizer when you registered with him.',
    wrongPassword:
      'Sorry, the password does not match. Please double check with the organizer team to get your valid password.',
    unknownError: 'An error has occured. Please try again or contact us if you need further support.',
    alreadyJoined: 'You already registered !',
    pleaseLogin: 'Please login to your FishFriender account to join this event.',
    joinedAlert: 'Event joined, congrats !',
  },
  ranking: {
    angler: 'Angler',
    catchNotFound: 'Catch not public anymore',
    individualNoRound: {
      noCatches: 'No catch logged during this contest',
    },
  },
}
